import Dialog from '@/components/Dialog';
import { type LevelProgressCoachComment } from '@/lib/types';
import { useContext, useState } from 'react';
import RubricsPortfolioContext from '@/lib/contexts/RubricsPortfolioContext';
import useApi from '@/lib/api/useApi';
import { Delete as DeleteIcon } from '@mui/icons-material';
import useRubricsPortfolioApiEndpoint from '../../../../useRubricsPortfolioApiEndpoint';
import { FormattedMessage } from 'react-intl';
import { IconButton } from '@mui/material';

type DeleteLevelProgressCoachCommentProps = {
  levelProgressCoachComment: LevelProgressCoachComment;
};

const DeleteLevelProgressCoachComment = ({
  levelProgressCoachComment,
}: DeleteLevelProgressCoachCommentProps) => {
  const api = useApi();
  const rubricsPortfolioApiEndpoint = useRubricsPortfolioApiEndpoint();

  const [, setPortfolio] = useContext(RubricsPortfolioContext);

  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const deleteCoachComment = async (): Promise<void> => {
    setConfirmationDialogOpen(false);
    setDeleting(true);

    await api.delete(
      `${rubricsPortfolioApiEndpoint}/level-progress-coach-comments/${levelProgressCoachComment.id}`,
    );

    setPortfolio(portfolio => {
      delete portfolio.levelProgressCoachComments![
        levelProgressCoachComment.levelId
      ][levelProgressCoachComment.id];
    });

    setDeleting(false);
  };

  return (
    <>
      <IconButton
        edge="end"
        size="small"
        color="error"
        onClick={() => setConfirmationDialogOpen(true)}
        disabled={deleting}
      >
        <DeleteIcon fontSize="small" />
      </IconButton>
      <Dialog
        open={confirmationDialogOpen}
        onClose={() => setConfirmationDialogOpen(false)}
        dangerous
      >
        <Dialog.Title>
          <FormattedMessage id="portfolio.level.attachments.level_progress_coach_comments.coach_comment.delete.dialog.title" />
        </Dialog.Title>
        <Dialog.Content>
          <Dialog.ContentText>
            <FormattedMessage id="portfolio.level.attachments.level_progress_coach_comments.coach_comment.delete.dialog.text" />
          </Dialog.ContentText>
        </Dialog.Content>
        <Dialog.Actions>
          <Dialog.Actions.CancelButton
            onClick={() => setConfirmationDialogOpen(false)}
          />
          <Dialog.Actions.DeleteButton onClick={deleteCoachComment} />
        </Dialog.Actions>
      </Dialog>
    </>
  );
};

export default DeleteLevelProgressCoachComment;
